import { useEffect, useState } from "react";
import type {
  QueryClient,
  QueryKey,
  UseQueryOptions,
} from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { ServiceResponse } from "~/api/axios";

/* This hook is used to save the Total Item number.
  This is needed because if we directly grab it from the pagination
  data, we would see a 0 while we are loading a new page */

export const usePaginatedQuery = <T extends ServiceResponse<unknown>>(
  options: UseQueryOptions<T, Error, T, QueryKey>,
  queryClient?: QueryClient | undefined,
) => {
  const [totalItems, setTotalItems] = useState<number | undefined>(undefined);

  const query = useQuery(options, queryClient);
  const total = query.data?.pagination?.total;

  useEffect(() => {
    if (total !== undefined) setTotalItems(total);
  }, [total]);

  return { query, totalItems };
};
